import { startCase } from "lodash";
import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { redMui } from "@ryde/theme";

import { ErrorsDisplayItemStyled } from "./errors-display.container.styled";

interface IErrorsDisplayItem {
  errorDescription: string;
}

export const ErrorsDisplayItem: FC<IErrorsDisplayItem> = ({
  errorDescription,
}) => {
  const errorDescriptionCapitalized = startCase(errorDescription ?? ""); // TODO: add translation solution
  return (
    <ErrorsDisplayItemStyled>
      <SVG_MUI.BellFilled color={redMui.A400} />
      <span> {errorDescriptionCapitalized}</span>
    </ErrorsDisplayItemStyled>
  );
};
